<template>
  <v-list>
    <v-list-item v-for="nav in navs" :key="nav.name" :to="nav.path">
      <v-list-item-action>
        <v-icon>{{ nav.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ nav.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-group
      prepend-icon="mdi-cog-outline">
      <template v-slot:activator>
          <v-list-item-title>Config</v-list-item-title>
      </template>
      <v-list-item link class="ml-4" v-for="nav in configs" :key="nav.name" :to="nav.path">
        <v-list-item-icon>
          <v-icon>{{nav.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{nav.name}}</v-list-item-title>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: "Navigation",

  data: () => ({
    navs: [
      { name: "Dashboard", path: "/", icon: "mdi-view-dashboard" },
      { name: "Ledger", path: "/ledger", icon: "mdi-file-document" },
      { name: "Register", path: "/register", icon: "mdi-book-open-variant" },
      { name: "Balance Sheet", path: "/balance-sheet", icon: "mdi-scale-balance"},
      { name: "Import", path: "/import", icon: "mdi-import" },
    ],
    configs: [
      { name: "Account", path: "/config/account", icon: "mdi-book-open-blank-variant" },
      { name: "Transaction type", path: "/config/transaction-type", icon: "mdi-tag" },
      { name: "Counterparty", path: "/config/counterparty", icon: "mdi-account" },
      { name: "Currency", path: "/config/currency", icon: "mdi-cash" },
    ]
  }),
};
</script>

<style lang="scss" scoped>
</style>